import { apiClient } from '../../../gateways/api'
import type { Werkbak } from '../../../opdrachten/types/Werkbak'

export { fetchCombiWerkbakken }

const fetchCombiWerkbakken = async (): Promise<Werkbak[]> => {
  const { data } = await apiClient({
    url: '/rest/opdracht/werkbakken',
    method: 'GET',
  })

  return data
}
